angular.module('dpw.components')

    /**
     * @ngdoc directive
     * @name dpwOnOffSwitcher
     * @restrict A
     * @param {expression} switcherModel
     * @param {function} onSwitchOn - A function which returns a promise or boolean value.
     * @param {function} onSwitchOff - A function which returns a promise or boolean value.
     * @description A switcher component with ON/OFF status.
     */
    .directive('dpwOnOffSwitcher', [function () {
        return {
            restrict: 'A',
            scope: {
                switcherModel: '=',
                onSwitchOn: '=',
                onSwitchOff: '=',
                isDisabled: '<'
            },
            bindToController: true,
            templateUrl: 'dpw-on-off-switcher.html',
            controllerAs: 'ctrl',
            controller: [function () {
                var self = this;

                self.onClickHandler = function () {
                    if (self.isDisabled) {
                        return;
                    }

                    var expectedStatus = !self.switcherModel;

                    var onSwitch = expectedStatus ? self.onSwitchOn : self.onSwitchOff;
                    _.isFunction(onSwitch) && performSwitch(expectedStatus, onSwitch);
                };

                function performSwitch(expectedStatus, onSwitch) {
                    var result = onSwitch();

                    if (_.isObject(result) && _.isFunction(result.then)) {
                        result.then(function onFulfilled() {
                            setSwitcherStatus(expectedStatus);
                        });
                    }

                    if (result === true) {
                        setSwitcherStatus(expectedStatus);
                    }
                }

                function setSwitcherStatus(newStatus) {
                    newStatus = newStatus !== false;
                    self.switcherModel = newStatus;
                }
            }]
        };
    }])

;
